module.exports = __webpack_public_path__ + "static/img/kjgl1.7ae9837.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/kjgl1.png
// module id = /p2G
// module chunks = 1